import React from 'react';
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
} from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    fontSize: '12',
    // backgroundColor: '#E4E4E4',
  },
  section: {
    margin: 20,
    padding: 10,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // flexGrow: 1,
  },
  titre: {
    // flexDirection: 'row',
    // justifyContent: 'center',
    // paddingTop: 20,
    // fontSize: 8,
    // alignItems: 'center',
    // fontStyle: 'italic',
  },
});

// Create Document Component
export const MyDocument = () => (
  <Document>
    <Page size='A4' orientation='portrait' style={styles.page}>
      <View style={styles.section}>
        <Text style={{ fontWeight: 'semibold', paddingTop: 20 }}>
          MINISTERE DE L'EDUCATION NATIONALE ET DE LA FORMATION PROFESSIONNELLE
        </Text>
        <Text style={{ marginTop: 16 }}>( M E N F P )</Text>
      </View>
      <View style={{ padding: '20' }}>
        <Text
          style={{
            marginLeft: 20,
            marginRight: 20,
            justifyContent: 'center',
            lineHeight: 2,
          }}
        >
          Le Ministere de l'Education Nationale et de la formation
          professionnelle certifie que le candidat xxxx né à Port-au-Prince le
          15 Juillet 1978 est inscrit aux seances des Examens du bac Permanent
          XXXX.
        </Text>
      </View>
    </Page>
  </Document>
);

const MyTestComponent = () => (
  <PDFViewer style={{ width: '80%', height: '600px' }}>
    <MyDocument />
  </PDFViewer>
);

export default MyTestComponent;

// import { Link, Text, View, StyleSheet } from '@react-pdf/renderer';

// const styles = StyleSheet.create({
//   container: {
//     flexDirection: 'row',
//     borderBottomWidth: 2,
//     borderBottomColor: '#112131',
//     borderBottomStyle: 'solid',
//     alignItems: 'stretch',
//   },
//   detailColumn: {
//     flexDirection: 'column',
//     flexGrow: 9,
//     textTransform: 'uppercase',
//   },
//   linkColumn: {
//     flexDirection: 'column',
//     flexGrow: 2,
//     alignSelf: 'flex-end',
//     justifySelf: 'flex-end',
//   },
//   name: {
//     fontSize: 24,
//     fontFamily: 'Lato Bold',
//   },
//   subtitle: {
//     fontSize: 10,
//     justifySelf: 'flex-end',
//     fontFamily: 'Lato',
//   },
//   link: {
//     fontFamily: 'Lato',
//     fontSize: 10,
//     color: 'black',
//     textDecoration: 'none',
//     alignSelf: 'flex-end',
//     justifySelf: 'flex-end',
//   },
// });

// const MyDocument = () => (
//   <View style={styles.container}>
//     <View style={styles.detailColumn}>
//       <Text style={styles.name}>Luke Skywalker</Text>
//       <Text style={styles.subtitle}>Jedi Master</Text>
//     </View>
//     <View style={styles.linkColumn}>
//       <Link style={styles.link}>luke@theforce.com</Link>
//     </View>
//   </View>
// );

// export default MyDocument;
